import React, { useState } from 'react';
import Box from 'components/elements/Box';
import Button from 'components/elements/button';
import Modal from 'components/utility/Modal/Modal';
import { ReactComponent as IconCustomize } from 'icons/icon-customize.svg';

import ViewContainer from '../Views/ViewContainer';
import Span from 'components/elements/span';
import { VariantElement } from './styles';
import { IOptionType } from './shared';

interface IMultiSelectListProps {
  title: string;
  variants: IOptionType[];
  applyVariants: (variants: string[]) => void;
  selectedVariants: string[];
  setShowModal: (show: boolean) => void;
  isNarrow?: boolean;
  hide: () => void;
}

const MultiSelectList: React.FC<IMultiSelectListProps> = ({
  title,
  variants,
  applyVariants,
  selectedVariants,
  setShowModal,
  isNarrow,
  hide,
}) => {
  const [selectedTempVariants, setSelectedTempVariants] = useState(
    selectedVariants || []
  );

  const toggle = (variant: IOptionType): void => {
    if (selectedTempVariants.includes(variant.value)) {
      setSelectedTempVariants(
        selectedTempVariants.filter((stv) => stv !== variant.value)
      );
    } else {
      setSelectedTempVariants([...selectedTempVariants, variant.value]);
    }
  };

  return (
    <ViewContainer title={title}>
      <>
        <Box display="flex" justifyContent="space-around" flexWrap="wrap" p={2}>
          {variants.map((variant: IOptionType) => {
            return (
              <VariantElement
                in4Rows={!isNarrow}
                isSelected={selectedTempVariants.includes(variant.value)}
                key={variant.value}
                onClick={(): void => {
                  toggle(variant);
                }}
                title={variant.label}
              >
                {variant.label}
              </VariantElement>
            );
          })}
        </Box>
        <Box display="flex" justifyContent="center">
          <Button
            onClick={hide}
            variant="secondary"
            alignSelf="center"
            justifySelf="center"
            fontWeight="600"
            borderRadius="3px"
            height="28px"
            py={1}
            px={4}
            mt={3}
            mb={2}
            mx={2}
            type="button"
          >
            Cancel
          </Button>
          <Button
            onClick={(): void => {
              applyVariants(selectedTempVariants);
              setShowModal(false);
            }}
            variant="primary"
            alignSelf="center"
            justifySelf="center"
            fontWeight="600"
            borderRadius="3px"
            height="28px"
            py={1}
            px={4}
            mt={3}
            mb={2}
            mx={2}
            type="button"
          >
            Apply Selected
          </Button>
        </Box>
      </>
    </ViewContainer>
  );
};

const OpenMultiselectList: React.FC<any> = (props) => {
  const [showModal, setShowModal] = useState(false);
  return (
    <>
      <Button
        variant="secondary"
        display="flex"
        alignItems="center"
        onClick={(): void => setShowModal(true)}
        type="button"
      >
        <IconCustomize />
        <Span pl={2}>Select variants</Span>
      </Button>
      {showModal && (
        <Modal
          isNarrow={props.isNarrow}
          hide={(): void => setShowModal(false)}
          canClickOutside={true}
        >
          <MultiSelectList
            {...props}
            hide={(): void => setShowModal(false)}
            setShowModal={setShowModal}
          />
        </Modal>
      )}
    </>
  );
};

export default OpenMultiselectList;
